import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardProgress } from '../components/WizardProgress';
import { useBookingStore } from '../store/bookingStore';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useLanguage } from '../locales/LanguageContext';

export const WizardLayout = ({ children, onNext, onBack, canGoNext = true }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const currentStep = useBookingStore(state => state.currentStep);
  const prevStep = useBookingStore(state => state.prevStep);
  
  const STEP_ROUTES = [
    '/',
    '/booking/select-vehicle',
    '/booking/service-details',
    '/booking/confirmation',
    '/booking/payment'
  ];
  
  const handleBack = () => {
    if (currentStep === 0 || currentStep === 1) {
      navigate('/');
    } else {
      prevStep();
      navigate(STEP_ROUTES[currentStep - 1]);
      if (onBack) onBack();
    }
  };
  
  return (
    <div className="min-h-screen bg-slate-50 py-4 sm:py-6 md:py-8">
      <div className="max-w-4xl mx-auto px-3 sm:px-4">
        <WizardProgress currentStep={currentStep} />
        
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm border border-slate-100 p-4 sm:p-6 md:p-8">
          {children}
          
          <div className="flex flex-col-reverse sm:flex-row justify-between gap-3 sm:gap-0 mt-6 sm:mt-8 pt-4 sm:pt-6 border-t border-slate-100">
            <button
              onClick={handleBack}
              className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 bg-white border border-slate-200 text-slate-700 
                hover:bg-slate-50 hover:border-slate-300 rounded-lg font-medium text-sm sm:text-base
                transition-colors flex items-center justify-center gap-2"
              data-testid="back-button"
            >
              <ArrowLeft className="w-4 h-4" />
              {t('wizard.back')}
            </button>
            
            {onNext && (
              <button
                onClick={onNext}
                disabled={!canGoNext}
                className="w-full sm:w-auto px-4 sm:px-6 py-2.5 sm:py-3 bg-navy-800 hover:bg-navy-900 text-white 
                  rounded-lg font-medium text-sm sm:text-base shadow-lg shadow-navy-800/20 
                  transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2
                  disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
                data-testid="next-button"
              >
                {t('wizard.continue')}
                <ArrowRight className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
